<template>
    <div class="deliveryYandexFood">
        <div class="body">
            <div class="img"><img src="@/assets/img/yandex-food/delivery.png" alt="доставка" /></div>
            <div class="phrase">{{ text }}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            text: "Теперь мы\n доставляем заказы\n через Яндекс Еду",
        };
    },
};
</script>

<style lang="scss" scoped>
.deliveryYandexFood {
    height: 100%;
    display: flex;
    align-items: center;
    .body {
        .img {
            width: 215px;
            height: 215px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
        .phrase {
            font-family: "Nunito Sans Bold";
            font-size: 16px;
            line-height: 25px;
            color: #000;
            white-space: pre-line;
        }
    }
}
</style>
